//import React from 'react';
import { useEffect, useRef, useState } from 'react';
import styled, { keyframes } from 'styled-components';
// import { SSpanTitle, SSpanTitleSmall } from '~/components/styles/styles';
// import { classic } from '~/themes';
import iconBattle from '@assets/images/background/mode-battle.svg';
import imgRoulette6 from '@assets/images/roulette/roulette-6.png';
import { StoredTheme } from '~/gql/theme/theme';
import imgRouletteCenter from '@assets/images/roulette/roulette-game-center.png';
import selection6Img from '@assets/images/roulette/roulette-6-selection.png';
import { Zone } from '~/data/types';
import { classic } from '~/themes';
import { useLingui } from '@lingui/react';
import { SSpanTitleSmall } from '~/components/styles/styles';

type IProps = {
  onSelectTheme: (name: string) => void;
  themes: StoredTheme[];
  turn: number;
  theme?: StoredTheme;
  onBonus: () => void;
};

//type CombinedThemeType = StoredTheme & Omit<Zone, "id"> & { idNum: number };

interface IChoiceTheme {
  id: number;
  title: string;
  mode: string;
  render: React.ReactNode;
}

const zones6: Zone[] = [
  // N
  {
    id: 1,
    type: 'poly',
    coords: [
      647, 171, 472, 476, 297, 167, 335, 149, 370, 138, 410, 127, 449, 123, 483,
      121, 524, 125, 556, 132, 590, 143, 618, 155,
    ],
    coordsStr:
      '647,171,472,476,297,167,335,149,370,138,410,127,449,123,483,121,524,125,556,132,590,143,618,155',
    name: 'Histoire du chemin de fer',
    rotate5: 180,
    angle: 0,
  },
  //NE
  {
    id: 1,
    type: 'poly',
    coords: [
      821, 473, 471, 473, 648, 171, 683, 195, 713, 220, 741, 251, 765, 283, 782,
      312, 800, 351, 809, 380, 818, 424,
    ],
    coordsStr:
      '821,473,471,473,648,171,683,195,713,220,741,251,765,283,782,312,800,351,809,380,818,424',
    name: 'Les trains en Europe et dans le monde',
    rotate5: -120,
    angle: 60,
  },
  //SE
  {
    id: 1,
    type: 'poly',
    coords: [
      647, 777, 472, 475, 822, 475, 823, 510, 817, 544, 808, 575, 794, 615, 776,
      652, 751, 688, 723, 716, 697, 744, 673, 761,
    ],
    coordsStr:
      '647,777,472,475,822,475,823,510,817,544,808,575,794,615,776,652,751,688,723,716,697,744,673,761',
    name: 'Les textes et les institutions',
    rotate5: -60,
    angle: 120,
  },
  //S
  {
    id: 1,
    type: 'poly',
    coords: [
      297, 775, 471, 474, 647, 775, 621, 791, 585, 806, 538, 817, 496, 825, 453,
      824, 414, 819, 370, 809, 331, 795, 307, 782,
    ],
    coordsStr:
      '297,775,471,474,647,775,621,791,585,806,538,817,496,825,453,824,414,819,370,809,331,795,307,782',
    name: 'Joker',
    rotate5: 0,
    angle: -180,
  },
  //SW
  {
    id: 1,
    type: 'poly',
    coords: [
      296, 775, 472, 473, 124, 473, 123, 508, 127, 541, 136, 578, 150, 612, 164,
      643, 184, 675, 205, 703, 230, 728, 259, 753,
    ],
    coordsStr:
      '296,775,472,473,124,473,123,508,127,541,136,578,150,612,164,643,184,675,205,703,230,728,259,753',
    name: 'Les infrastructures et l’exploitation',
    rotate5: 60,
    angle: -120,
  },
  //NW
  {
    id: 1,
    type: 'poly',
    coords: [
      125, 472, 471, 473, 297, 169, 274, 182, 245, 206, 217, 233, 191, 262, 168,
      299, 151, 339, 136, 375, 128, 415, 123, 453,
    ],
    coordsStr:
      '125,472,471,473,297,169,274,182,245,206,217,233,191,262,168,299,151,339,136,375,128,415,123,453',
    name: 'Les véhicules',

    rotate5: 120,
    angle: -60,
  },
];

const choiceInit: IChoiceTheme = {
  id: 1,
  title: 'Choisis un thème',
  mode: 'mode battle',
  render: <></>,
};

type TProps = IProps; // & ReturnType<typeof mapStateToProps> & TRootAction

export function ChoiceBattleTheme({
  onSelectTheme,
  turn,
  theme,
  onBonus,
}: TProps) {
  const { i18n } = useLingui();
  const [selectedZone, setSelectedZone] = useState<Zone | undefined>(undefined);
  const [rouletteHeight, setRouletteHeight] = useState<number>(1);
  const [rouletteWidth, setRouletteWidth] = useState<number>(1);
  const observedDiv = useRef<HTMLImageElement>(null);

  const [selectedAngle, setSelectedAngle] = useState<number | undefined>(
    undefined
  );

  useEffect(() => {
    if (theme || turn === undefined) {
      return;
    }
    setSelectedZone(undefined);
    setSelectedAngle(0);

    const randomAngle = Math.floor(Math.random() * zones6.length);
    setSelectedAngle(zones6[randomAngle].angle);

    setTimeout(() => {
      setSelectedZone(zones6[randomAngle]);
      if (zones6[randomAngle].name === 'Joker') {
        setTimeout(() => {
          onBonus();
          setSelectedZone(undefined);
          setTimeout(() => {
            setSelectedAngle(0);
          }, 1000);
        }, 1000);
      } else {
        setTimeout(() => {
          onSelectTheme(zones6[randomAngle].name);
          setSelectedZone(undefined);
          setSelectedAngle(0);
        }, 1000);
      }
    }, 3000);
  }, [turn]);

  useEffect(() => {
    if (!observedDiv.current) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      if (observedDiv?.current?.offsetWidth !== rouletteWidth) {
        setRouletteWidth(observedDiv?.current?.offsetWidth ?? 1);
      }
      if (observedDiv?.current?.offsetHeight !== rouletteHeight) {
        setRouletteHeight(observedDiv?.current?.offsetHeight ?? 1);
      }
    });
    resizeObserver.observe(observedDiv.current);

    return function cleanup() {
      resizeObserver.disconnect();
    };
  }, [observedDiv, rouletteHeight, rouletteWidth, turn]);

  return (
    <Container>
      {choiceInit && (
        <>
          <SDivRouletteWrapper>
            <SRoulette id="roulette">
              <SDivTitle>
                <img src={iconBattle} alt="" />
              </SDivTitle>
              <SRouletteImgMoved
                $angleValue={0}
                id="roulette"
                src={imgRoulette6}
                alt=""
              />
              {selectedZone !== undefined && (
                <SImgSelection5
                  $rotate={selectedZone?.rotate5}
                  src={selection6Img}
                  alt=""
                />
              )}
              <RotatingImage
                $angleValue={selectedAngle || 0}
                src={imgRouletteCenter}
                alt=""
              />
              {!selectedZone && (
                <SDivFooterText>
                  <SDivFeedback>
                    <SPFeedback>{i18n._('battle.your.turn')}</SPFeedback>
                  </SDivFeedback>
                </SDivFooterText>
              )}
              {selectedZone && (
                <SDivFooterText>
                  <SDivFeedback>
                    <SSpanTitleSmall
                      $marginBottom="0"
                      $color={classic.token?.colorText}
                    >
                      Thème
                    </SSpanTitleSmall>
                    <SSpan $align="center" $color={classic.token?.colorText}>
                      {selectedZone.name}
                    </SSpan>
                  </SDivFeedback>
                </SDivFooterText>
              )}
            </SRoulette>
          </SDivRouletteWrapper>
        </>
      )}
    </Container>
  );
}

const SSpan = styled.span<{
  $color?: string;
  $align?: string;
}>`
  color: ${classic.token?.colorText};
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  -webkit-text-stroke-width: 0.8px;
  -webkit-text-stroke-color: #fff;

  font-family: 'Riffic Free', sans-serif;
  font-weight: 700;
  font-size: 1.3rem;
  margin-bottom: 10px;
  text-align: ${({ $align }) => ($align ? $align : 'center')};
  user-select: none;
  @media screen and (max-height: 450px) {
    font-size: 1.1rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 1.1rem;
  }
`;

export const SPFeedback = styled.p<{
  $color?: string;
  $align?: string;
  $margin?: string;
}>`
  color: ${classic.token?.colorText};
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  -webkit-text-stroke-width: 0.8px;
  -webkit-text-stroke-color: #fff;

  font-family: 'Riffic Free', sans-serif;
  font-weight: 700;
  font-size: 1.2rem;
  margin: ${({ $margin }) => ($margin ? $margin : '10px 0 20px 0')};
  text-align: ${({ $align }) => ($align ? $align : 'center')};
  user-select: none;
  @media screen and (max-height: 450px) {
    margin-bottom: 10px;
    font-size: 1rem;
  }
  @media screen and (max-width: 450px) {
    font-size: 1rem;
  }
`;

const SDivFeedback = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    #fff 50%,
    rgba(255, 255, 255, 0) 100%
  );

  padding: 0 30px;
  width: auto;
`;

const SImgSelection5 = styled.img<{ $rotate?: number }>`
  position: absolute;
  top: 0;
  left: 50%;
  height: 100%;
  transform: ${({ $rotate }) =>
    $rotate ? `translateX(-50%) rotate(${$rotate}deg)` : 'translateX(-50%)'};
  width: auto;
  pointer-events: none;

  @media screen and (max-width: 450px) {
    top: 50%;
    left: 0;
    height: auto;
    width: 100%;
    transform: ${({ $rotate }) =>
      $rotate ? `translateY(-50%) rotate(${$rotate}deg)` : 'translateY(-50%)'};
  }
`;

const Container = styled.div<{ disabled?: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  user-select: none;
  height: 100%;
  position: relative;
`;

const SDivTitle = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 10%;
  width: 100%;
  position: absolute;
  top: -5%;
  left: 0;
  width: 100%;

  img {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: contain;
    height: 100%;
    width: 100%;
  }

  @media screen and (max-width: 450px) {
    height: 10%;
    top: -0.5%;
  }
`;

const SDivFooterText = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  height: 8%;
  width: 100%;
  bottom: -5%;
  left: 0;
  width: 100%;
  img {
    position: absolute;
    top: 0;
    left: 0;
    object-fit: contain;
    height: 100%;
    width: 100%;
  }

  @media screen and (max-width: 450px) {
    height: 8%;
  }
`;

const SDivRouletteWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  height: 80%;
  width: 100%;
`;

const SRoulette = styled.div`
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  position: relative;
  width: auto;
  pointer-events: none;

  @media screen and (orientation: portrait) {
    height: auto;
    width: 100%;
  }
`;

const rotateAnimation = ($angleValue: number) => keyframes`
  from {
    transform:  rotate(0deg);
  }
  to {
    transform:  rotate(${1080 + $angleValue}deg);
  }
`;

const RotatingImage = styled.img<{
  $angleValue: number;
  $shouldAnimate?: boolean;
}>`
  position: absolute;
  object-fit: contain;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;

  animation: ${({ $angleValue }) => rotateAnimation($angleValue)} 2s ease-out
    forwards;
  animation-delay: 1s;
`;

const SRouletteImgMoved = styled.img<{ $angleValue: number }>`
  height: 100%;
  width: auto;
  max-width: 100%;
  max-height: 100%;
  pointer-events: none;
  transform: ${({ $angleValue }) => `rotate(${$angleValue}deg)`};
  transition: transform 3000ms ease-in-out;

  @media screen and (orientation: portrait) {
    height: auto;
    width: 100%;
  }
`;
